/**
 * AI replies learners flagged from speak (store review; migration 0449).
 *
 *   GET /admin/ai-content-reports?reason=&surface=&cursor= — newest first.
 */
import { get } from './_core.js';

export type AiReportReason = 'offensive' | 'incorrect' | 'other';
export type AiReportSurface = 'conversation' | 'session_history' | 'theory_chat';

export interface AiContentReport {
  id: string;
  userId: string;
  email: string;
  sessionId: string | null;
  turnIndex: number | null;
  surface: AiReportSurface;
  reason: AiReportReason;
  comment: string | null;
  text: string;
  createdAt: string;
}

export interface AiContentReportFilters {
  reason?: AiReportReason | undefined;
  surface?: AiReportSurface | undefined;
  cursor?: string | undefined;
}

export async function fetchAiContentReports(
  filters: AiContentReportFilters = {},
): Promise<{ reports: AiContentReport[]; nextCursor: string | undefined }> {
  const params = new URLSearchParams();
  if (filters.reason) params.set('reason', filters.reason);
  if (filters.surface) params.set('surface', filters.surface);
  if (filters.cursor) params.set('cursor', filters.cursor);
  const qs = params.toString();
  const res = await get<{ reports: AiContentReport[] }>(
    `/admin/ai-content-reports${qs ? `?${qs}` : ''}`,
  );
  return { reports: res.data.reports, nextCursor: res.meta?.nextCursor };
}
